import { addRendition } from '@shared/utils/photoRendition';

export type Rendition = 'small'; // A tested subset of media service rendition choices. Medium is default and not included.

export function isMediaServiceUrl(url: string) {
  // prettier-ignore
  return url.startsWith('https://withjoy.com/media')
      || url.startsWith('https://dev.withjoy.com/media');
}

export const applyRenditionIfMediaServiceUrl = (url: string, rendition?: 'small') => {
  return isMediaServiceUrl(url) ? addRendition({ url, renditionSize: rendition ?? 'medium' }) : url;
};
